import {IBrandsProps} from 'brandComponents/Brands/IBrands';

export enum EBrandsSectionTypes {
	'Alphabetic Scroll' = 'alphabetic-scroll',
	'Collapsible' = 'collapsible',
}

export interface IBrandsContentfulProps extends Omit<IBrandsProps, 'type'> {
	sys: {id: string};
	type: EBrandsSectionTypes;
	itemsCollection?: {
		items: object[];
	};
}

export interface IBrand {
	category: string;
	sys: {id: string};
	targetPage: {sys: {id: string}; slug: string};
	title: string;
}

export interface IBrandTransformed {
	id: string;
	label: string;
	url: string;
}
